import type { Theme } from '@mui/material/styles'

export const iconButtonSx = {
  color: (theme: Theme) => theme.palette.text.primary,
  borderRadius: '6px',
  padding: 0.5,
}
